import decode from 'jwt-decode';
import { getToken } from './localStorage';

interface MyToken {
  id: string;
  email: string;
  username: string;
  isSupport: string;
  isAdmin: string;
  exp: number;
}

export const decodeToken = () => {
  const token = getToken();
  const info = token ? decode<MyToken>(token) : null;
  return info;
};

export const isTokenExpired = (token: string) => {
  try {
    const decoded = decode<MyToken>(token);
    if (decoded.exp < Date.now() / 1000) {
      return true;
    } else return false;
  } catch (err) {
    return false;
  }
};
